import React from 'react';
import { Loader2 } from 'lucide-react';

export default function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-zinc-50 border border-zinc-200 rounded-2xl animate-pulse">
      <Loader2 className="h-8 w-8 text-[#004B87] animate-spin mb-3" />
      <p className="text-sm font-bold text-zinc-500 uppercase tracking-widest">Carregando Ferramentas...</p>
    </div>
  );
}
